import React from 'react';
import { Link } from 'react-router-dom';
import voca from 'voca';
import { chatGptModels } from 'drapcode-constant';
import { convertTimeStampToDate } from '../../../common/utils/dateUtils';

export const GptTableRow = ({
  projectId,
  version,
  externalApi,
  externalapi,
  handleClone,
  handleDelete,
}) => {
  const { deleteExternalApiPending } = externalapi;

  const getCollectionTitle = (collectionName) => {
    const { collections, inMemoryCollections } = externalapi;
    const collection = [...collections, ...inMemoryCollections].find(
      (e) => e.collectionName === collectionName,
    );
    return collection ? collection.collectionTitle : collectionName;
  };

  const generateEditUrl = (externalApi) => {
    return (
      <Link
        to={`/externalapi/${version}/v/${projectId}/chatGpt/${externalApi.uuid}/update`}
        className="btn btn-xs btn-primary"
        title={`Edit ${externalApi.externalApiName}`}
      >
        <i className="wb webconnect-pencil"></i>
      </Link>
    );
  };

  const getChatGptModelName = (model) => {
    const modelObj = chatGptModels.find((mdl) => mdl.value === model);
    return modelObj ? modelObj.label : model;
  };

  const { uuid, externalApiName, collectionName, setting, createdAt } = externalApi;
  const { model } = setting;
  return (
    <tr key={uuid} className="text-left td-align-middle">
      <td title={externalApiName}>{voca.truncate(externalApiName, 30)}</td>
      <td>{getChatGptModelName(model)}</td>
      <td title={getCollectionTitle(collectionName)}>
        {voca.truncate(getCollectionTitle(collectionName), 25)}
      </td>
      <td>{convertTimeStampToDate(createdAt)}</td>
      <td className="text-right">
        {generateEditUrl(externalApi)}
        &nbsp;
        <button
          className="btn btn-xs btn-theme-submit"
          onClick={() => handleClone(externalApi)}
          title={`Clone ${externalApiName}`}
        >
          <i className="wb webconnect-clone"></i>
        </button>
        &nbsp;
        <button
          className="btn btn-xs btn-theme-delete"
          onClick={() => handleDelete(externalApi.uuid)}
          disabled={deleteExternalApiPending}
          title={`Delete ${externalApiName}`}
        >
          <i className="wb webconnect-trash-solid"></i>
        </button>
      </td>
    </tr>
  );
};
